module.exports = __webpack_public_path__ + "img/9791185072357.0fb9cc53.jpg";